// Cocktails - Ranked by Global Popularity & Order Frequency
// Difficulty: EASY - Popular bar culture knowledge

export const cocktailsData = [
  { id: 1, name: "Margarita", rank: 1, image: "/images/cocktails/margarita.png" },
  { id: 2, name: "Old\nFashioned", rank: 2, image: "/images/cocktails/old_fashioned.png" },
  { id: 3, name: "Mojito", rank: 3, image: "/images/cocktails/mojito.png" },
  { id: 4, name: "Martini", rank: 4, image: "/images/cocktails/martini.png" },
  { id: 5, name: "Cosmopolitan", rank: 5, image: "/images/cocktails/cosmopolitan.png" },
  { id: 6, name: "Manhattan", rank: 6, image: "/images/cocktails/manhattan.png" },
  { id: 7, name: "Negroni", rank: 7, image: "/images/cocktails/negroni.png" },
  { id: 8, name: "Piña\nColada", rank: 8, image: "/images/cocktails/pina_colada.png" },
  { id: 9, name: "Daiquiri", rank: 9, image: "/images/cocktails/daiquiri.png" },
  { id: 10, name: "Whiskey\nSour", rank: 10, image: "/images/cocktails/whiskey_sour.png" },
  { id: 11, name: "Moscow\nMule", rank: 11, image: "/images/cocktails/moscow_mule.png" },
  { id: 12, name: "Bloody\nMary", rank: 12, image: "/images/cocktails/bloody_mary.png" },
  { id: 13, name: "Espresso\nMartini", rank: 13, image: "/images/cocktails/espresso_martini.png" },
  { id: 14, name: "Mai\nTai", rank: 14, image: "/images/cocktails/mai_tai.png" },
  { id: 15, name: "Aperol\nSpritz", rank: 15, image: "/images/cocktails/aperol_spritz.png" },
  { id: 16, name: "Tom\nCollins", rank: 16, image: "/images/cocktails/tom_collins.png" },
  { id: 17, name: "Gin and\nTonic", rank: 17, image: "/images/cocktails/gin_and_tonic.png" },
  { id: 18, name: "Mint\nJulep", rank: 18, image: "/images/cocktails/mint_julep.png" },
  { id: 19, name: "French\n75", rank: 19, image: "/images/cocktails/french_75.png" },
  { id: 20, name: "Bellini", rank: 20, image: "/images/cocktails/bellini.png" },
  { id: 21, name: "Sazerac", rank: 21, image: "/images/cocktails/sazerac.png" },
  { id: 22, name: "Caipirinha", rank: 22, image: "/images/cocktails/caipirinha.png" },
  { id: 23, name: "Paloma", rank: 23, image: "/images/cocktails/paloma.png" },
  { id: 24, name: "Sidecar", rank: 24, image: "/images/cocktails/sidecar.png" },
  { id: 25, name: "Pisco\nSour", rank: 25, image: "/images/cocktails/pisco_sour.png" },
  { id: 26, name: "White\nRussian", rank: 26, image: "/images/cocktails/white_russian.png" },
  { id: 27, name: "Sex on\nthe Beach", rank: 27, image: "/images/cocktails/sex_on_the_beach.png" },
  { id: 28, name: "Irish\nCoffee", rank: 28, image: "/images/cocktails/irish_coffee.png" },
  { id: 29, name: "Aviation", rank: 29, image: "/images/cocktails/aviation.png" },
  { id: 30, name: "Boulevardier", rank: 30, image: "/images/cocktails/boulevardier.png" },
];
